var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfosGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16602 5.6665C8.16602 6.12675 8.5391 6.49984 8.99935 6.49984C9.4596 6.49984 9.83268 6.12675 9.83268 5.6665C9.83268 5.20625 9.4596 4.83317 8.99935 4.83317C8.5391 4.83317 8.16602 5.20625 8.16602 5.6665Z",
    fill: "#9B9DA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16601 12.3332C8.16601 12.7934 8.5391 13.1665 8.99935 13.1665C9.4596 13.1665 9.83268 12.7934 9.83268 12.3332L9.83268 8.58317C9.83268 8.12292 9.4596 7.74984 8.99935 7.74984C8.5391 7.74984 8.16601 8.12292 8.16601 8.58317V12.3332Z",
    fill: "#9B9DA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 0.666504C13.6017 0.666504 17.3327 4.39746 17.3327 8.99984C17.3327 13.6022 13.6017 17.3332 8.99935 17.3332C4.39697 17.3332 0.666016 13.6022 0.666016 8.99984C0.666016 4.39746 4.39697 0.666504 8.99935 0.666504ZM8.99935 2.33317C5.31745 2.33317 2.33268 5.31794 2.33268 8.99984C2.33268 12.6818 5.31745 15.6665 8.99935 15.6665C12.6813 15.6665 15.666 12.6818 15.666 8.99984C15.666 5.31794 12.6813 2.33317 8.99935 2.33317Z",
    fill: "#9B9DA0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfosGray);
export default __webpack_public_path__ + "static/media/infosGray.f7e52ed747fd343ff3be814916009f2a.svg";
export { ForwardRef as ReactComponent };